import b from 'b_';
import cx from 'classnames';
import React, { useCallback } from 'react';

import { PrepLessonsHotIcon } from '../__hot-icon/prep-lessons__hot-icon';
import { BackgroundImage } from '../../background-image/background-image';
import Checkbox from '../../checkbox/checkbox';
import { CHECKBOX_TYPES } from '../../constants';
import Text from '../../text/text';

import './prep-lessons__item-content.scss';

interface OwnProps {
    checked?: boolean;
    coverFile?: string | null;
    coverTitle?: string;
    isHot?: boolean;
    name: string;
    onCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    published: boolean;
    shouldShowCheckbox?: boolean;
    shouldShowNotPublishedLabel?: boolean;
    tag?: string;
}

interface Props extends OwnProps {}

export const PrepLessonsItemContent = (props: Props) => {
    const {
        checked,
        coverFile,
        coverTitle,
        isHot,
        name,
        onCheckboxChange,
        published,
        shouldShowCheckbox,
        shouldShowNotPublishedLabel,
        tag,
    } = props;

    const handleCheckboxChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (onCheckboxChange) {
                onCheckboxChange(e);
            }
        },
        [onCheckboxChange]
    );

    return (
        <>
            <div className="prep-lessons__cover-overlay" onClick={(e) => e.stopPropagation()}>
                {shouldShowCheckbox && (
                    <Checkbox
                        checked={checked}
                        mix="prep-lessons__item-checkbox"
                        onChange={handleCheckboxChange}
                        preventClickPropagation={true}
                        type={CHECKBOX_TYPES.BLUE}
                    />
                )}
                {tag && (
                    <span className="prep-lessons__tag">
                        <Text size={Text.SIZE.S}>{tag}</Text>
                    </span>
                )}
                {isHot && <PrepLessonsHotIcon />}
            </div>
            <div className={b('prep-lessons__item-cover', { compact: Boolean(name) })}>
                {coverFile && (
                    <BackgroundImage
                        mix="prep-lessons__item-cover-img"
                        objectFit="cover"
                        src={coverFile}
                        title={coverTitle}
                    />
                )}
            </div>
            {name && (
                <div className="prep-lessons__item-title">
                    <Text size={Text.SIZE.XL}>{name}</Text>
                </div>
            )}
            <div className="prep-lessons__item-info">
                {shouldShowNotPublishedLabel && !published && (
                    <span className={cx('prep-lessons__item-not-published')}>
                        <Text id="prepLessons.hidden" />
                    </span>
                )}
            </div>
        </>
    );
};

const component = React.memo(PrepLessonsItemContent);
component.displayName = 'PrepLessonItem';

export default component;
